import { render, staticRenderFns } from "./RequestCreatorService.vue?vue&type=template&id=38dc2d8f&scoped=true&"
import script from "./RequestCreatorService.vue?vue&type=script&lang=js&"
export * from "./RequestCreatorService.vue?vue&type=script&lang=js&"
import style0 from "./RequestCreatorService.vue?vue&type=style&index=0&id=38dc2d8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc2d8f",
  null
  
)

export default component.exports